import { render, staticRenderFns } from "./FileV2.vue?vue&type=template&id=552562c0&scoped=true"
import script from "./FileV2.vue?vue&type=script&lang=js"
export * from "./FileV2.vue?vue&type=script&lang=js"
import style0 from "./FileV2.vue?vue&type=style&index=0&id=552562c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552562c0",
  null
  
)

export default component.exports